/* eslint-disable react-hooks/exhaustive-deps */
import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import { ReactComponent as TickIcon } from "assets/icons/tick.svg";
import { ReactComponent as DropDownIcon } from "assets/icons/dropdownIcon.svg";
import React, { useEffect, useState } from "react";
import {
    Dropdown as RBDropDown,
    FormControl,
    InputGroup,
    Spinner,
} from "react-bootstrap";
import { DropDownItemType, DropDownProps } from "./DropDown.props";
import { useLocation } from "react-router-dom";
import "./style.scss";

const CustomToggle = React.forwardRef<HTMLDivElement, any>(
    ({ children, onClick, disabled }, ref) => (
        <div
            className={`custom-toggle ${disabled && "disabled"}`}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <span style={{ color: `${disabled ? "#CFD3D2" : "#495057"}` }}>
                {children}
            </span>
            <DropDownIcon />
        </div>
    )
);

const DropDown: React.FC<DropDownProps> = ({
    data,
    disabled,
    loading,
    title,
    containerClassName,
    defaultTitle = "انتخاب کنید",
    type,
    hasSelectItem = false,
    className,
    getSelectedItem,
    hasShowAll,
    defaultActiveItem,
    label,
    search,
    onChangeSearch,
    resetData,
    setResetData,
    name,
    vendorSelected,
    isFoodSelectBox,
    inputData,
}) => {
    const [selectedItem, setSelectedItem] = useState<
        DropDownItemType | undefined
    >(defaultActiveItem);
    const [searchValue, setSearchValue] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        if (data && hasShowAll) {
            data.unshift({
                id: 0,
                title: `نمایش ‌همه‌ی ${title + " "}ها `,
            });
            setSelectedItem(data[0]);
        }
    }, [data]);

    useEffect(() => {
        if (data && !!hasSelectItem && data[0]?.title !== `انتخاب کنید`) {
            data.unshift({
                id: 0,
                title: `انتخاب کنید`,
            });
            setSelectedItem(data[0]);
        }
    }, [data]);

    useEffect(() => {
        if (
            (defaultActiveItem?.id === 0 ||
                defaultActiveItem?.title === undefined) &&
            inputData?.inputFlag === "parentFlag"
        ) {
            setSelectedItem(undefined);
        } else setSelectedItem(defaultActiveItem);
    }, [defaultActiveItem]);

    useEffect(() => {
        if (resetData && setResetData) {
            setSelectedItem(undefined);
            setResetData(false);
        }
    }, [resetData]);

    useEffect(() => {
        if (onChangeSearch) {
            onChangeSearch("", label || title, isOpen);
        }
        setSearchValue("");
    }, [isOpen]);

    const handleItemClick = (item: DropDownItemType) => {
        getSelectedItem(item);
        setSelectedItem(item);
    };

    const onChange = (value: any) => {
        setSearchValue(value);
        if (onChangeSearch) {
            onChangeSearch(value, label || title, isOpen);
        }
    };

    const hasToRenderClassname = (item: DropDownItemType, index: number) => {
        return (
            ("id" in item && item.id === selectedItem?.id) ||
            (!("id" in item) && index === selectedItem?.id)
        );
    };

    const isOfflinePage = pathname.includes("offline-invoice");
    const getTitle = (item: any) => {
        if (isOfflinePage) {
            if (!vendorSelected && isFoodSelectBox) {
                return `${item.title} - ${item?.vendor?.title}`;
            }
            return item.vendor_title || item.title || item.name;
        }
        if (name?.includes("offlinesale") && item.title !== "undefined") {
            return `${item.title} - ${item.vendor?.title}`;
        } else {
            return item.title || item.name;
        }
    };

    return (
        <div className={containerClassName}>
            {!!label && <span className="pr-2">{label}</span>}
            <RBDropDown
                // @ts-ignore
                variant="Secondary"
                className={`${className} rtl dropdown-wrapper`}
                onToggle={(e) => setIsOpen(e)}
                data-testid="dropdown"
            >
                <RBDropDown.Toggle
                    as={CustomToggle}
                    id="dropdown-basic"
                    disabled={disabled}
                >
                    {selectedItem ? (
                        <>
                            <span className="selected-item">
                                {selectedItem?.title ||
                                    selectedItem?.name ||
                                    data?.find(
                                        //@ts-ignore
                                        (el) => el.id === selectedItem
                                    )?.name ||
                                    data?.find(
                                        //@ts-ignore
                                        (el) => el.id === selectedItem
                                    )?.title}
                            </span>
                        </>
                    ) : defaultTitle ? (
                        defaultTitle
                    ) : (
                        title
                    )}
                </RBDropDown.Toggle>

                <RBDropDown.Menu
                    className={`${type} w-100 menu-design`}
                    data-testid="dropdown-menu"
                >
                    {search && !disabled ? (
                        <InputGroup className="search-wrapper">
                            <SearchIcon className="search-icon" />
                            <FormControl
                                autoFocus
                                className="mx-3 my-2 w-auto"
                                placeholder="جستجو..."
                                onChange={(e) => onChange(e.target.value)}
                                value={searchValue}
                                disabled={disabled}
                            />
                        </InputGroup>
                    ) : null}
                    {data && !disabled
                        ? data.map((item, index) => (
                              <RBDropDown.Item
                                  disabled={disabled || false}
                                  key={item.id || item.snappfood_id || index}
                                  onClick={() =>
                                      handleItemClick(
                                          "id" in item
                                              ? item
                                              : //@ts-ignore
                                                { ...item, id: index }
                                      )
                                  }
                                  className={
                                      hasToRenderClassname(item, index)
                                          ? `${type}-active`
                                          : ""
                                  }
                              >
                                  {type === "with-tick" && (
                                      <TickIcon className="tick-icon" />
                                  )}
                                  {getTitle(item)}
                              </RBDropDown.Item>
                          ))
                        : null}{" "}
                    {!data && !disabled ? (
                        <RBDropDown.Item className="w-100 d-flex align-items-center justify-content-center">
                            آیتمی وجود ندارد
                        </RBDropDown.Item>
                    ) : null}
                    {loading && (
                        <RBDropDown.Item className="w-100 d-flex align-items-center justify-content-center">
                            <Spinner animation="border" role="status" />
                        </RBDropDown.Item>
                    )}
                </RBDropDown.Menu>
            </RBDropDown>
        </div>
    );
};

export default DropDown;
